class Covidence.Document extends Covidence.RelationalModel

  initialize: (options) ->
    super()
    @file = options.file
    @set("upload_file_name", @file.name)
    @set('upload_content_type', @file.type) if 'type' of @file
    @set('upload_file_size', @file.size) if 'size' of @file
    @set('upload_updated_at', @file.lastModifiedDate) if 'lastModifiedDate' of @file
    @